import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  CustomGitHubTeamsField,
  validateGitHubTeams,
} from './CustomGitHubTeamsField';

export const CustomGitHubTeamsFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'CustomGitHubTeamsField',
    component: CustomGitHubTeamsField,
    validation: validateGitHubTeams,
  }),
);
